import type {CustomPropertiesPagePayload} from '@github-ui/custom-properties-types'
import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {Box, Label} from '@primer/react'

import {PropertiesList} from '../components/PropertiesList'
import {CurrentOrgRepoProvider} from '../contexts/CurrentOrgRepoContext'
import {RepoSettingsCustomPropertiesPage} from './RepoSettingsCustomPropertiesPage'

export function CustomPropertiesPage() {
  const {definitions, properties, errors, ...payload} = useRoutePayload<CustomPropertiesPagePayload>()
  const newRepoPropertiesEditUIEnabled = useFeatureFlag('repo_properties_editing')

  if (newRepoPropertiesEditUIEnabled && 'currentRepo' in payload) {
    return <RepoSettingsCustomPropertiesPage />
  }

  return (
    <CurrentOrgRepoProvider>
      <Box sx={{display: 'flex', alignItems: 'center', gap: 3}}>
        <Box as="h2" className="Subhead-heading">
          Custom properties{' '}
          <Label variant="success" sx={{verticalAlign: 'middle'}}>
            Beta
          </Label>
        </Box>
      </Box>
      <Box as="hr" sx={{mt: 2, mb: 4}} />
      <PropertiesList definitions={definitions} properties={properties} errors={errors} />
    </CurrentOrgRepoProvider>
  )
}

try{ CustomPropertiesPage.displayName ||= 'CustomPropertiesPage' } catch {}